import React, { useState } from 'react';

import CustomSelect from '../common/CustomSelect';

const DataSelect = ({
  useGetQuery, 
  onChange,
  label = '',
  filter = {}, 
  queryOptions = {},
  mapRowToOption = row => ({value: row.id, label: row.name}),
  ...props
}) => {  
  const query = useGetQuery(filter, queryOptions);
  if (query.isLoading || query.isError) <></>;
  return (
    <CustomSelect
      label={label}
      disabled={props?.disabled || query.isLoading}
      options={(query?.data?.data || []).map(mapRowToOption)}
      {...props}
      onChange={e => onChange(e, e.target.value)}
    />
  );
};

export default DataSelect;